export const mimeTypes = Object.freeze({
  avi: 'video/x-msvideo',
  mp4: 'video/mp4',
  mpeg: 'video/mpeg',
  ogv: 'video/ogg',
  ts: 'video/mp2t',
  webm: 'video/webm',
  apng: 'image/apng',
  avif: 'image/avif',
  bmp: 'image/bmp',
  gif: 'image/gif',
  ico: 'image/vnd.microsoft.icon',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  webp: 'image/webp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  anyImage: 'image/*',
  anyVideo: 'video/*',
}) as Record<string, string>

export const IMAGES_MIME_TYPES = Object.values(mimeTypes).filter((el) => el.includes('image/'))
export const VIDEO_MIME_TYPES = Object.values(mimeTypes).filter((el) => el.includes('video/'))
export const APPLICATION_MIME_TYPES = Object.values(mimeTypes).filter((el) =>
  el.includes('application/')
)
export const DOCX_MIME_TYPES = [mimeTypes.doc, mimeTypes.docx]
export const XLSX_MIME_TYPES = [mimeTypes.xls, mimeTypes.xlsx]
export const PPTX_MIME_TYPES = [mimeTypes.ppt, mimeTypes.pptx]
export const PDF_MIME_TYPE = mimeTypes.pdf
